import React from 'react';
import styled, { css } from 'styled-components';
import { variables } from '../../../styles/variables';

interface Props {
  areEffectsPaired: boolean;
  children: React.ReactNode;
}
export const Info = styled(({ children, areEffectsPaired, ...props }: Props) => <div {...props}>{children}</div>)`
  font-size: 1.8rem;
  font-weight: 400;
  float: right;
  text-align: right;
  p {
    margin-bottom: 0;
  }
  span {
    display: inline-block;
    margin-left: .8rem;
    ${({ areEffectsPaired }) => !areEffectsPaired && css`
        color: ${variables.colorDecorator};
        font-weight: 600;
    ` }
  }
`;
